import { IAuthContext } from '../../common/hooks/outsetaAuthProvider';
import { IAuthenticationProvider } from "../../common/types";
import { StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum } from '../../common/clients/ogg';

export default class OutsetaAuthenticationProvider implements IAuthenticationProvider {
    authContext: IAuthContext;

    constructor(authContext: IAuthContext) {
        this.authContext = authContext;
    }

    accessTokenType: StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum = StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum.Outseta;

    async getBearerToken(): Promise<string> {
        console.debug("Getting bearer token");
        return this.authContext.accessToken;
    }
    
    async getUserEmail(): Promise<string> {
        console.debug("Getting user email");
        return this.authContext.user.Email;
    }

}